export enum AcoesCrudEnum {
  Adicionar = 'ADICIONAR',
  Detalhes = 'DETALHES',
  Atualizar = 'ATUALIZAR',
  Deletar = 'DELETAR'
}

export enum AcoesExtraEnum {
  Dashboard = 'DASHBOARD',
  Ativar = 'ATIVAR',
  Desativar = 'DESATIVAR',
  Cancelar = 'CANCELAR',
  Abrir = 'ABRIR'
}

export enum AcoesInvestimentoEnum {
  Enviar_Boleto = 'ENVIAR BOLETO',
  Recusar = 'RECUSAR',
  Por_Em_Analise = 'PÔR EM ANÁLISE',
  Assinar = 'ASSINAR',
  Confirmar = 'CONFIRMAR'
}
